import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { toast } from "sonner";
import { reserveBootcamp, reserveModule } from "../lib/api";

export default function ReserveDialog({ open, onOpenChange, item, kind, onReserved }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  if (!item) return null;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (kind === "bootcamp") {
        await reserveBootcamp({ session_id: item.id, customer_name: name, customer_email: email });
      } else {
        await reserveModule({ module_id: item.id, customer_name: name, customer_email: email });
      }
      toast.success("Seat reserved.", { description: "We'll be in touch with details shortly." });
      onOpenChange(false);
      setName("");
      setEmail("");
      onReserved?.();
    } catch (err) {
      const msg = err?.response?.data?.detail || "Reservation failed. Try again.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-obsidian-700 border-white/10 text-white" data-testid="reserve-dialog">
        <DialogHeader>
          <DialogTitle className="font-bebas text-3xl uppercase tracking-wide">
            Reserve — <span className="text-gold-400">{item.title}</span>
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 pt-2">
          <div>
            <Label className="text-zinc-400 uppercase tracking-widest text-xs">Full name</Label>
            <Input
              data-testid="reserve-name-input"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="bg-obsidian-900 border-white/10 text-white rounded-none mt-1"
            />
          </div>
          <div>
            <Label className="text-zinc-400 uppercase tracking-widest text-xs">Email</Label>
            <Input
              data-testid="reserve-email-input"
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-obsidian-900 border-white/10 text-white rounded-none mt-1"
            />
          </div>
          <p className="text-xs text-zinc-500 font-mono">
            No payment collected in this demo — we'll confirm your seat by email.
          </p>
          <DialogFooter>
            <Button
              type="submit"
              disabled={loading}
              data-testid="reserve-submit-btn"
              className="w-full bg-gradient-to-r from-gold-400 to-gold-500 text-black hover:brightness-110 rounded-none font-bebas text-lg tracking-wider"
            >
              {loading ? "Reserving..." : "Confirm Reservation"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
